export type ToastVariant = 'info' | 'success' | 'warning' | 'error'

/** Text button rendered in the toast slot row (e.g. "Action"). */
export interface ToastAction {
  label: string
  onClick: () => void
}

/** Link rendered in the toast slot row (e.g. "Learn more"). Opens `href` in a new tab when provided. */
export interface ToastLink {
  label: string
  href?: string
  onClick?: () => void
}

/**
 * Options accepted by the `toast.*` helpers.
 */
export interface ToastOptions {
  /** Secondary line displayed below the message (was `description`). */
  caption?: string
  /** Structured action button shown in the action row. */
  action?: ToastAction
  /** Structured link shown in the action row. */
  link?: ToastLink
  /** Auto-close duration in ms. Defaults to 5s (or 10s when a caption/action/link is present) when omitted. */
  duration?: number
}

/** Per-variant icon + icon / close icon background color mapping. Background/text colors are handled in CSS. */
export const TOAST_VARIANT_CONFIG: Record<ToastVariant, { icon: string, iconColor: string, closeIconBackground: string }> = {
  info: { icon: 'info', iconColor: 'icon-info', closeIconBackground: 'surface-brand-bold-hover' },
  success: { icon: 'check_circle', iconColor: 'icon-success', closeIconBackground: 'surface-brand-bold-hover' },
  warning: { icon: 'warning', iconColor: 'icon-warning', closeIconBackground: 'surface-brand-bold-hover' },
  error: { icon: 'emergency_home', iconColor: 'icon-inverted', closeIconBackground: 'surface-danger-bold-hover' },
}
